import VMasker from 'vanilla-masker';

const formatCNPJorCPF = string => {
    if (!string) return null;

    let formart = "999.999.999-99";

    if (string.length > 11) {
        formart = "99.999.999/9999-99";
    }

    return VMasker.toPattern(string, formart);
}

const formatPhone = string => {
    if (!string) return null;
    return VMasker.toPattern(string, "(99) 9999-9999");
}

const formatAddressJson = (data = {}) => {
    return `${data.address || ''}, ${data.district || ''}, ${data.city || ''} - ${data.state || ''}`;
}

const formatMoney = string => {
    if (!string) return null;
    return VMasker.toMoney(string, { unit: 'R$' });
}

export default {
    formatPhone,
    formatMoney,
    formatCNPJorCPF,
    formatAddressJson
}



// WEBPACK FOOTER //
// ./src/psuite-js/helpers/formatter.js